import { useEffect, useState, useRef } from "react";
import axios from "axios";
import Loading from "../../Components/Loading/Loading";
import ListContent from "../../Components/AboutUsComponents/ListContent/ListContent";
import Persons from "../../Components/AboutUsComponents/Persons/Persons";
import ClientSlider from "../../Components/AboutUsComponents/ClientSlider/ClientSlider";
import "./AboutUs.css";

const AboutUs = () => {
  const [aboutUsData, setAboutUsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isFetchedAboutList = useRef(false); // ✅ Prevents duplicate API call

  useEffect(() => {
    if (!isFetchedAboutList.current) {
      fetchAboutUs();
      isFetchedAboutList.current = true; // ✅ Ensure it runs only once
    }
  }, []);
  const fetchAboutUs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}api/AboutUs`
      );

      setAboutUsData(response.data.length > 0 ? response.data[0] : null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="aboutus-container">
      {aboutUsData.contentList && aboutUsData.contentList.length > 0 && (
        <ListContent content={aboutUsData.contentList} />
      )}
      {aboutUsData.persons && aboutUsData.persons.length > 0 && (
        <Persons person={aboutUsData.persons} />
      )}
      {aboutUsData.clients && aboutUsData.clients.length > 0 && (
        <ClientSlider clients={aboutUsData.clients} />
      )}
      <div className="about-desc-container">
        <p
          className="description1"
          dangerouslySetInnerHTML={{ __html: aboutUsData.description1 }}
        ></p>
        <p
          className="description2"
          dangerouslySetInnerHTML={{ __html: aboutUsData.description2 }}
        ></p>
      </div>
    </div>
  );
};

export default AboutUs;
